const cache: { [lang: string]: string } = {}

export const getLanguageName = (langCode: string) => {
  if (!(langCode in cache)) {
    const names = new Intl.DisplayNames([langCode], { type: 'language' })
    const name = names.of(langCode)
    if (name === undefined) console.warn('getLanguageName: name not found for', langCode)
    const fallback = name || '' // SAFE: empty string fallback when language name not yet loaded
    cache[langCode] = fallback[0].toUpperCase() + fallback.substring(1)
  }

  return cache[langCode]
}
